module.exports = __webpack_public_path__ + "static/media/logo.62341b4a.png";